// Workspace metadata KLM-8948

import React from "react";
import { dispatch } from "@rematch/core"
import _ from "lodash";
import { Form } from "formsy-semantic-ui-react";
import { withRouter } from 'react-router-dom';
import LoadingComponent from "../../../common/LoadingComponent";

import {
  Button,
  Header,
  Message,
  Modal,
  Grid,
} from "semantic-ui-react";

class MetaData extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
          isJSONValid: true,
          updatedMetaDataSchema: undefined,
          updatedMetaDataId: "",
          loader: false
        };
    }

    componentWillMount() {
        if(this.props.workspaceMetaData.metaData) {
            this.setState({
                updatedMetaDataSchema: this.props.workspaceMetaData.metaData,
                updatedMetaDataId: this.props.workspaceMetaData._id
            })
        }
    }

    close = () => {
        this.props.setMetaDataFlag(false);
    };

    IsValidJSONString = (e, data) => {
        try {
          JSON.parse(e.target.value);
        } catch (e) {
          this.setState({ isJSONValid: false });
          return false;
        }
        this.setState({
          isJSONValid: true,
          updatedMetaDataSchema: JSON.parse(e.target.value),
        });
        return true;
    };

    async saveMetaData() {
        // Below changes for KLM-9001
        this.setState({loader: true})
        let payload = {
            metaData: this.state.updatedMetaDataSchema
        }
        dispatch.workspaceMetaData.addMetaData(payload).then(() => {
            dispatch.workspaceMetaData.getMetaData()
            this.props.refPreMeta(this.state.updatedMetaDataSchema)
            this.props.setMetaDataFlag(false);
            this.setState({loader: false})
        })
    }

    async saveUpdatedMetaData() {
        // Below changes for KLM-9001
        this.setState({loader: true})
        let payload = {
            _id: this.state.updatedMetaDataId,
            metaData: this.state.updatedMetaDataSchema
        }
        dispatch.workspaceMetaData.updateMetaData(payload).then(() => {
            dispatch.workspaceMetaData.getMetaData()
            this.props.refPreMeta(this.state.updatedMetaDataSchema)
            this.props.setMetaDataFlag(false);
            this.setState({loader: false})
        })
    }

    render() {
        const errorLabel = <div className="customErrorLabel" />;

        return (
            <div>
            <LoadingComponent active={this.state.loader} message="Saving Metadata... " />
            <Modal
            open={this.props.open}
            onClose={this.close}
            size="small"
            closeOnEscape={false}
            closeOnDimmerClick={false}
          >
                <Header content={`Manage Metadata `}/>
                <Modal.Content>
                <Form
                noValidate
                ref={(ref) => (this.form = ref)}
                className="formcyForm"
                name="cretePack"
                id="cretePackID"
                >
                    <Grid>
                        <Grid.Row>
                            <Grid.Column width={16}>
                                <Form.TextArea
                                    required
                                    name="rule"
                                    label="Metadata"
                                    id="Condition"
                                    onChange={(e, data) => this.IsValidJSONString(e, data)}
                                    value={JSON.stringify(this.state.updatedMetaDataSchema)}
                                    errorLabel={errorLabel}
                                    style={{ minHeight: "300px" }}
                                    instantValidation
                                />
                                {!this.state.isJSONValid ? (
                                    <Message
                                    className="bg-warning"
                                    style={{
                                        float: "left",
                                        padding: "8px",
                                        width: "calc(100% - 200px)",
                                        textAlign: "center",
                                    }}
                                    content="Please enter valid JSON"
                                    />
                                ) : null}
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        className="button-cancel"
                        onClick={this.close}>Close</Button>
                {this.state.updatedMetaDataId === "" ? 
                    <Button
                    className="button-submit"
                    // id="cancelSchema"
                    onClick={() => this.saveMetaData()}
                    disabled={!this.state.isJSONValid ? true : false}
                >
                    Save
                </Button> : 
                    <Button
                    className="button-submit"
                    // id="cancelSchema"
                    onClick={() => this.saveUpdatedMetaData()}
                    disabled={!this.state.isJSONValid ? true : false}
                >
                    Save
                </Button>}
                </Modal.Actions>
            </Modal>
            </div>
        )
    }
}

export default withRouter(MetaData)